// import axios from "axios";
import api from '../axiosInstance'; 
import { APP_SETTINGS } from "../../../../config";
import { getFilteredQuery } from "app/assets/genericActions";

const getAuthHeaders = (token) => {
  if (!token) {
    console.error("Token is missing for API request.");
    return {};
  }
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

export const createLeaveApi = (leaveData, token) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(APP_SETTINGS.API_PATH.LEAVE.create, leaveData, config);
};

export const getAllLeavesApi = (filters, token) => {
  const url = `${APP_SETTINGS.API_PATH.LEAVE.getAll}?${getFilteredQuery(
    filters
  )}`;
  return api.get(url, getAuthHeaders(token));
};

export const updateLeaveApi = (leaveId, leaveData, token) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  const url = `${APP_SETTINGS.API_PATH.LEAVE.update}/${leaveId}`;
  return api.patch(url, leaveData, config);
};

export const deleteLeaveApi = (leaveId, token) => {
  const url = `${APP_SETTINGS.API_PATH.LEAVE.delete}/${leaveId}`;
  return api.delete(url, getAuthHeaders(token));
};

export const approveOrRejectLeaveApi = (leaveId, approved, token) => {
  const payload = { approved };
  const url = `${APP_SETTINGS.API_PATH.LEAVE.approveOrReject}/${leaveId}/status`;
  return api.post(url, payload, getAuthHeaders(token));
};

export const getLeaveByIdApi = (id, token) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get(`${APP_SETTINGS.API_PATH.LEAVE.getById}/${id}`, config);
};